<template lang="pug">
.rating-group
  RatingHeader(:type="type", :text="headerText")
  RatingGroupItem(
    v-for="(place, place_id) in places",
    :key="place_id",
    :type="type",
    :place="place",
    :ratingDataRank="getDataByRank(place)"
  )
</template>

<script>
import RatingHeader from "./RatingHeader";
import RatingGroupItem from "./RatingGroupItem";

export default {
  name: "RatingGroup",
  components: {
    RatingHeader,
    RatingGroupItem,
  },
  props: {
    type: {
      type: String,
      default: "bronze",
    },
    places: {
      type: Array,
      default: () => [],
    },
    ratingData: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    headerText() {
      return this.$t(`promo.rating.header.${this.type}`)
    },
  },
  methods: {
    getDataByRank(rank) {
      return this.ratingData.hasOwnProperty(rank) ? this.ratingData[rank] : {};
    },
  },
};
</script>
